import React from "react";

// Images
import logo from "../../images/logos/viewgener-logo-premium.png";

// Video
import heroVideo from "../../videos/viewgener-hero-earth-v2.mp4";

// Icons
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// Stylesheets
import "./Top.scss";

const Top = () => {
    return (
        <section className="top" id="top">
            <video
    className="bg-video"
    autoPlay
    muted
    loop
    playsInline
>
    <source src={heroVideo} type="video/mp4" />
</video>
            <div className="logo-rise-wrapper centered">
                <img src={logo} alt="Logo" className="logo" />
            </div>
            <a href="#about" className="scroll-down smooth-scroll">
                <KeyboardArrowDownIcon className="centered" />
            </a>
        </section>
    );
};

export default Top;